import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {api} from "../../../maps/data";
import {addOrDeleteQueryParams, getQueryValue} from "../../../domain/queryHandler";
import {useLocation, useNavigate} from "react-router-dom";
import useZibi from "../../../zibi/UseZibi";
import Dialog from "@mui/material/Dialog";
import Tx from "../../Tx";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Text from "../../Text";
import {ValidatorForm} from "react-material-ui-form-validator";

const WrapperStyled = styled.div`
    min-width: 500px;
`;


const EdgeEditModal = () => {
    const history = useNavigate();
    const location = useLocation();

    const editEdgeId = getQueryValue(location, 'edgeEdit');

    const [siteEdges] = useZibi('siteEdges');

    const edge = siteEdges.find(node => node?._id === editEdgeId);

    const [floorName, s_floorName] = useState('');
    const [edgeIp, s_edgeIp] = useState('');
    const [addressIp, s_addressIp] = useState('');

    useEffect(() => {
        if (edge) {
            s_floorName(edge.floorName);
            s_edgeIp(edge.edgeIp);
            s_addressIp(edge.udpAddr);
        }
    }, [edge]);

    const changeUrl = (query) => {
        history({
            search: query
        });
    };

    const closeModal = () => {
        const urlToPush = addOrDeleteQueryParams(location, [{edgeEdit: null}]);
        changeUrl(urlToPush);
    };

    const save = async () => {
        const data = {
            floorName,
            edgeIp,
            edgeId: edge._id,
        };

        if (addressIp) {
            data.udpAddr = addressIp;
        }
        await api({
            type: 'intallerEditClientEdge',
            data: data
        });
        closeModal();
    };

    return (
        <Dialog
            open={true}
            onClose={closeModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <WrapperStyled>
                <DialogTitle id="alert-dialog-title">
                    {<Tx>edge.edit.title</Tx>}
                </DialogTitle>
                <DialogContent style={{paddingTop: 5}}>
                    <ValidatorForm
                        onSubmit={save}
                        onError={errors => console.log(errors)}>
                        <Text
                            label="edge.floorName"
                            value={floorName}
                            onChange={s_floorName}
                            validators={['required']}
                            errorMessages={['this field is required']}/>
                        <Text
                            label="edge.ipLabel"
                            value={edgeIp}
                            onChange={s_edgeIp}
                            validators={['required']}
                            errorMessages={['this field is required']}/>
                        <Text
                            label="edge.udpAddressLable"
                            value={addressIp}
                            onChange={s_addressIp}
                        />
                    </ValidatorForm>
                </DialogContent>

                <DialogActions>

                    <Button onClick={() => {
                        closeModal();
                    }}><Tx>g.cancel</Tx></Button>
                    <Button autoFocus type="submit">
                        <Tx>g.save</Tx>
                    </Button>

                </DialogActions>
            </WrapperStyled>
        </Dialog>
    );
};

export default EdgeEditModal;